// Styles
import "./styles.scss";

//react
import { useEffect, useRef, useState } from "react";
import { PAUSE_TIMER_EVENT, RESUME_TIMER_EVENT } from "../../constants/const";

const TimerBar = (props) => {
  const [timer_countdown, setTimer_countdown] = useState(100);
  const timerBarInterval = useRef()
  let step = 100 / Number(props.time);

  const triggetCountDown = () => {
    timerBarInterval.current = setInterval(() => {
      if (timer_countdown > 0) {
        setTimer_countdown(countdown => countdown - step)
      } else {
        setTimer_countdown(0)
      }
    }, 1000)
  }

  const handlePauseTimer = () => {
    clearInterval(timerBarInterval.current)
  }

  useEffect(() => {
    triggetCountDown()
    window.addEventListener(PAUSE_TIMER_EVENT, handlePauseTimer)
    window.addEventListener(RESUME_TIMER_EVENT, triggetCountDown)
    return () => {
      clearInterval(timerBarInterval.current)
      window.removeEventListener(PAUSE_TIMER_EVENT, handlePauseTimer)
      window.removeEventListener(RESUME_TIMER_EVENT, triggetCountDown)
    }
  }, [])

  return (
    <div className="timerBar-root">
      <div className="timer-bar-container">
        <div className="timer-bar">
          <div
            // style={{ animationDuration: `${props.time}s` }}
            style={{ width: `${timer_countdown}%` }}
            className="timer"
          ></div>
        </div>
      </div>
    </div>
  );
};

export default TimerBar;
